module.exports = __webpack_public_path__ + "static/img/product_anomaly.9368e0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_anomaly.jpg
// module id = u8bI
// module chunks = 0